import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { ESSENTIAL_APP_STATES } from '@app/graphql/queries';
import { Splash } from '@impargo/components/Splash';
import { Offstage } from '@impargo/reusable-components';
import { useMemo } from 'react';
import { GeocodingContext } from './GeocodingContext';
const CompanyContextProvider = ({ children }) => {
    const { loading, data } = useQuery(ESSENTIAL_APP_STATES, { fetchPolicy: 'network-only' });
    const geocodingCountries = useMemo(() => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.geocodingSettings.allowedCountries) !== null && _a !== void 0 ? _a : []; }, [data === null || data === void 0 ? void 0 : data.geocodingSettings.allowedCountries]);
    return (_jsxs(GeocodingContext.Provider, Object.assign({ value: { geocodingCountries } }, { children: [_jsx(Offstage, Object.assign({ showIf: loading }, { children: _jsx(Splash, { "data-testid": 'splash-screen' }) })), _jsx(Offstage, Object.assign({ showIf: !loading }, { children: children }))] })));
};
export default CompanyContextProvider;
